<div class="scrollable-content">
  <!-- Sidebar -->
  @if (!isMobile()) {
    <glxy-nav-layout>
      <glxy-nav-item
        [class.selected]="viewAllSelected()"
        (click)="handleTabChange(objectType(), true, objectSubtype())"
      >
        <div class="tab-name" [class.selected]="viewAllSelected()">{{ 'ACTIONS.SELECTED' | translate }}</div>
        <glxy-nav-item-accessory>
          <glxy-badge class="tab-badge" [class.selected]="viewAllSelected()" [size]="'small'">
            {{ totalAssociations() }}
          </glxy-badge>
        </glxy-nav-item-accessory>
      </glxy-nav-item>
      @for (tab of associationTabs$ | async; track tab) {
        @let isSelected = isSelectedTab(tab.objectType, tab.objectSubtype)();
        <glxy-nav-item
          [class.selected]="isSelected"
          (click)="handleTabChange(tab.objectType, false, tab.objectSubtype)"
        >
          <div class="tab-name" [class.selected]="isSelected">{{ tab.name }}</div>
          <glxy-nav-item-accessory>
            <glxy-badge class="tab-badge" [class.selected]="isSelected" [size]="'small'">
              {{ getGroupTotalAssociations(tab.objectType, tab.objectSubtype)() }}
            </glxy-badge>
          </glxy-nav-item-accessory>
        </glxy-nav-item>
      }
    </glxy-nav-layout>
  }
  <!-- Content -->
  <glxy-page-wrapper>
    <div class="content-options">
      @if (isMobile()) {
        <div class="tab-menu-dropdown-title">{{ 'ASSOCIATIONS.ACTIONS.TITLE' | translate }}</div>
        <div class="spacing">
          <button mat-stroked-button class="tab-menu-dropdown" [matMenuTriggerFor]="tabMenu">
            {{ getCurrentTabName() | async }}
            <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
          </button>
          <mat-menu #tabMenu="matMenu">
            <button mat-menu-item (click)="handleTabChange(objectType(), true, objectSubtype())">
              {{ 'ACTIONS.SELECTED' | translate }}
            </button>
            @for (tab of associationTabs$ | async; track tab) {
              <button mat-menu-item (click)="handleTabChange(tab.objectType, false, tab.objectSubtype)">
                {{ tab.name }}
              </button>
            }
          </mat-menu>
        </div>
        <mat-divider />
      }
      <glxy-form-field prefixIcon="search">
        <input type="text" [placeholder]="'ACTIONS.SEARCH' | translate" matInput [formControl]="searchCtrl" />
      </glxy-form-field>
      @if (viewAllSelected()) {
        @let displayedAssociationGroups = displayedAssociationGroups$ | async;
        @if (!isLoadingSelectedView()) {
          @for (group of displayedAssociationGroups; track group) {
            @if (group.associations?.length > 0) {
              <glxy-form-field class="no-bottom-spacing">
                <div class="options-group-title">
                  <glxy-label>{{ group.name }}</glxy-label>
                </div>
                @for (association of group.associations; track association.crmObjectId) {
                  @let isLast = isLastAssociation(association);
                  <div
                    (mouseenter)="isLast && lastAssociationPopover.open()"
                    (mouseleave)="lastAssociationPopover.close()"
                  >
                    <mat-checkbox
                      [checked]="isSelectedAssociation(association, group.objectType)"
                      [disabled]="isLast"
                      [glxyPopover]="lastAssociationPopover"
                      (change)="onCheckboxChange($event, association, group.objectType)"
                    >
                      {{ association.name }}
                    </mat-checkbox>
                  </div>
                  <glxy-popover #lastAssociationPopover>
                    <div>{{ 'ACTIVITY_LOGGER.EMPTY_ASSOCIATIONS' | translate }}</div>
                  </glxy-popover>
                }
              </glxy-form-field>
            }
          }
        } @else {
          <glxy-loading-spinner />
        }
      } @else {
        @if (!isLoadingOptions()) {
          <glxy-form-field>
            @for (option of options(); track option.crmObjectId) {
              @let isLast = isLastAssociation(option);
              <div (mouseenter)="isLast && lastAssociationPopover.open()" (mouseleave)="lastAssociationPopover.close()">
                <mat-checkbox
                  [checked]="isSelectedAssociation(option, objectType())"
                  [disabled]="isLast"
                  [glxyPopover]="lastAssociationPopover"
                  (change)="onCheckboxChange($event, option, objectType())"
                >
                  {{ option.name }}
                </mat-checkbox>
              </div>
              <glxy-popover #lastAssociationPopover>
                <div>{{ 'ACTIVITY_LOGGER.EMPTY_ASSOCIATIONS' | translate }}</div>
              </glxy-popover>
            }
          </glxy-form-field>
        } @else {
          <glxy-loading-spinner />
        }
      }
    </div>
    <!-- Actions -->
    <mat-dialog-actions class="dialog-actions">
      <button mat-stroked-button (click)="handleCancel()">
        {{ 'ACTIONS.CANCEL' | translate }}
      </button>
      <button mat-flat-button color="primary" (click)="handleSave()">
        {{ 'ACTIONS.SAVE' | translate }}
      </button>
    </mat-dialog-actions>
  </glxy-page-wrapper>
</div>
